import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#050505] text-gray-400 py-12 border-t border-[#1A1A1A]" data-id="element-138">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-139">
        <div className="text-center space-y-4" data-id="element-140">
          <h3 className="text-2xl font-bold text-[#D4A843]" data-id="element-141">
            Salud en tu plato
          </h3>
          <p className="text-gray-500" data-id="element-142">Material educativo profesional.</p>
          <div className="border-t border-[#1A1A1A] pt-6 mt-6" data-id="element-143">
            <p className="text-sm text-gray-600" data-id="element-144">
              © {new Date().getFullYear()} Salud en tu plato. Todos los
              derechos reservados.
            </p>
            <p className="text-xs text-gray-700 mt-2" data-id="element-145">
              Este es material educativo de apoyo profesional. No reemplaza la
              formación académica ni la supervisión profesional. Diseñado para
              uso en contextos educativos formales en Argentina.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}